/**
 * @file taskHelpers.js
 * @description Shared TMS helper functions for badge classes and date formatting.
 * Extracted from duplicated code across TasksByUser, AdminDashboard, TasksByState, etc.
 */

/**
 * Returns Tailwind classes for a priority badge.
 * @param {string} priority
 * @returns {string}
 */
export const getPriorityBadgeClass = (priority) => {
  switch (priority) {
    case "Critical":
    case "High":
      return "bg-rose-100 text-rose-700 border border-rose-200 px-2.5 py-0.5 rounded-full text-xs font-bold tracking-wide inline-block";
    case "Medium":
      return "bg-amber-50 text-amber-700 border border-amber-200 px-2.5 py-0.5 rounded-full text-xs font-semibold tracking-wide inline-block";
    case "Low":
    default:
      return "bg-emerald-50 text-emerald-700 border border-emerald-200 px-2.5 py-0.5 rounded-full text-xs font-semibold tracking-wide inline-block";
  }
};

/**
 * Returns Tailwind classes for a status badge.
 * @param {string} status
 * @returns {string}
 */
export const getStatusBadgeClass = (status) => {
  switch (status) {
    case "Open":
      return "bg-blue-50 text-blue-700 border border-blue-200 px-2.5 py-0.5 rounded-full text-xs font-semibold tracking-wide inline-block";
    case "In Progress":
      return "bg-purple-50 text-purple-700 border border-purple-200 px-2.5 py-0.5 rounded-full text-xs font-semibold tracking-wide inline-block";
    case "On Hold":
      return "bg-amber-100 text-amber-800 border border-amber-200 px-2.5 py-0.5 rounded-full text-xs font-semibold tracking-wide inline-block";
    case "Closed":
    default:
      return "bg-slate-100 text-slate-700 border border-slate-300 px-2.5 py-0.5 rounded-full text-xs font-semibold tracking-wide inline-block";
  }
};

/**
 * Formats a Firestore Timestamp or date value to a locale date string.
 * @param {Object|string|number} timestamp
 * @returns {string}
 */
export const formatFirestoreDate = (timestamp) => {
  if (!timestamp) return "—";
  if (timestamp.toDate && typeof timestamp.toDate === "function") {
    return timestamp.toDate().toLocaleDateString();
  }
  return new Date(timestamp).toLocaleDateString();
};

/** Priority sort weights for sort comparisons. */
export const PRIORITY_WEIGHT = {
  High: 3,
  Critical: 3,
  Medium: 2,
  Low: 1,
};

/** State color definitions for filter pill styling. */
export const STATE_COLORS = {
  "Open": { active: { backgroundColor: "#2563eb", color: "#fff", borderColor: "#2563eb" } },
  "In Progress": { active: { backgroundColor: "#7c3aed", color: "#fff", borderColor: "#7c3aed" } },
  "On Hold": { active: { backgroundColor: "#d97706", color: "#fff", borderColor: "#d97706" } },
  "Closed": { active: { backgroundColor: "#475569", color: "#fff", borderColor: "#475569" } },
};
